export default "__VITE_ASSET__ClLR3ooH__"